export default function formatPhoneToTelAttr(phone) {
  return phone.replace(/(\s|-|\(|\))/g, '');
}